<template>
<div>
  <!-- 서버 OS 정보 -->
      <el-row type="flex" class="title-bar" justify="space-between">
        <div class="title-h3">서버 OS 정보</div>
        <div>
          최근 수집시간 : <em>{{osCheckDatetime}}</em>
          <el-button class="cmp-margin-left" size="small" type="primary" @click="reloadOSInfo()">서버 OS 정보 갱신</el-button>
        </div>
      </el-row>
      <el-row class="list form-list mr-b30" :gutter="10">
        <el-col :span="12" class="mr-b15">
          <el-form ref="form" label-position="left">
            <el-form-item label="장비명" label-width="100px"><span>{{ osInfoData.objName ? osInfoData.objName : '-' }}</span></el-form-item>
            <el-form-item label="IP 주소" label-width="100px"><span>{{ osInfoData.ipaddress ? osInfoData.ipaddress : '-' }}</span></el-form-item>
            <el-form-item label="구동 시간" label-width="100px"><span>{{ osInfoData.uptime ? osInfoData.uptime : '-' }}</span></el-form-item>
            <el-form-item label="관리자 (정/부)" label-width="100px"><span>{{ osInfoData.adminLabel}}</span></el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form ref="form" label-position="left">
            <el-form-item label="OS" label-width="100px">{{ osInfoData.osName ? osInfoData.osName : '-' }}</el-form-item>
            <el-form-item label="서비스 팩" label-width="100px">{{ osInfoData.osServicepackVer ? osInfoData.osServicepackVer : '-' }}</el-form-item>
            <el-form-item label="시스템 종류" label-width="100px">{{ osInfoData.osArchtecture  ? osInfoData.osArchtecture : '-' }}</el-form-item>
            <el-form-item label="도메인 정보" label-width="100px">{{ osInfoData.domain ? osInfoData.domain : '-'}}</el-form-item>
          </el-form>
        </el-col>
      </el-row>
  <!-- TODO: OS 파라미터 정보 설계 완료 후 추가 개발 예정 -->
  <!-- <el-row>
    <w-panel>
      <el-row slot="perfHeader">
        <el-col :span="6">
          <h3>OS 파라미터 정보</h3>
        </el-col>
      </el-row>
      <el-row :gutter="10" slot="perfBody">
        <el-col :span="12">

        </el-col>
      </el-row>
    </w-panel>
  </el-row> -->
  <!-- 환경 변수 -->
      <el-row type="flex" class="title-bar" justify="space-between">
        <div class="title-h3">환경 변수</div>
        <div>
          <el-button size="small" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="tableData" :column-default="columnDefault" :columns="columns" :pagination="false" :show-custom-header="true"
      :show-search-tool="showSearchTool" style="width:100%;" v-loading="isLoading">
      </el-table-wrapper>
</div>
</template>

<script>
import moment from 'moment';
import serverInfoAPI from '@/api/config/server/server-info';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { isNil } from 'lodash';
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WOsInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      tableData: [],
      isLoading: false,
      osInfoData: {},
      osCheckDatetime: null,
      showSearchTool: false,
      params: {
        objId: null,
      },
      columns: [{
        prop: 'USERNAME',
        label: '환경 변수 사용자',
        sortable: true,
        width: 300,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'NAME',
        label: '환경 변수 명',
        sortable: true,
        width: 300,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      {
        prop: 'VALUE',
        label: '정보',
        sortable: true,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    activeTab: {
      handler() {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadStore();
      },
    },
  },
  methods: {
    /**
     * [exportExcel 환경 변수 목록 엑셀 출력]
     * @author yelim
     * @return {[type]}
     */
    exportExcel() {
      const me = this;
      if (!isNil(me.osInfoData)) {
        const osObj = {
          objId: me.osInfoData.objId,
          ciInstanceId: me.osInfoData.ciInstanceId,
          ipaddressApplytype: me.osInfoData.ipaddressApplytype,
        };
        if (!isNil(me.osInfoData.ipaddressIpv4)) {
          osObj.ipaddressIpv4 = me.osInfoData.ipaddressIpv4;
        }
        if (!isNil(me.osInfoData.ipaddressIpv6)) {
          osObj.ipaddressIpv6 = me.osInfoData.ipaddressIpv6;
        }
        serverInfoAPI.exportOsEnvInfo(osObj)
          .then((response) => {
            if (response.data.success && !isNil(response.data.data)) {
              FileApi.downloadExportedExcelFile(response.data.data);
            } else {
              this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          });
      }
    },
    /**
     * [reloadOSInfo 서버 OS 정보 갱신]
     * @author yelim
     * @return {[type]}
     */
    reloadOSInfo() {
      const me = this;
      if (!isNil(me.osInfoData)) {
        const osObj = {
          objId: me.osInfoData.objId,
          ciInstanceId: me.osInfoData.ciInstanceId,
          ipaddressApplytype: me.osInfoData.ipaddressApplytype,
        };
        if (!isNil(me.osInfoData.ipaddressIpv4)) {
          osObj.ipaddressIpv4 = me.osInfoData.ipaddressIpv4;
        }
        if (!isNil(me.osInfoData.ipaddressIpv6)) {
          osObj.ipaddressIpv6 = me.osInfoData.ipaddressIpv6;
        }

        const target = '서버 OS 정보';
        const action = msgUtil.action.RUN;
        serverInfoAPI.executeOsInfo(osObj).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            me.osInfoData = Object.assign({}, this.nodeParams);
            me.loadStore();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
    /**
     * [loadStore 서버의 Os정보를 가져온다.]
     * @author yelim
     * @return {[type]}
     */
    loadStore() {
      const action = msgUtil.action.VIEW;
      const me = this;
      if (!isNil(this.osInfoData) && this.activeTab === this.$options.name) {
        serverInfoAPI.getServerInfoList(this.params).then((result) => {
          if (result.data.success) {
            const serverResult = result.data.data.data;
            this.osInfoData = Object.assign({}, serverResult);
            this.osInfoData.adminLabel = `[${serverResult.majorDepartment ? serverResult.majorDepartment : '-'}]${serverResult.majorName ? serverResult.majorName : '-'} /
            [${serverResult.minorDepartment ? serverResult.minorDepartment : '-'}]${serverResult.minorName ? serverResult.minorName : '-'}`;
            this.osCheckDatetime = this.checkDatetimeFormatter(result.data.data.checkDatetime);
          } else {
            this.$message(msgUtil.getResultMsgData(action, '서버 OS 정보', false));
          }
        }).then(() => {
          const osObj = {
            objId: me.osInfoData.objId,
            ciInstanceId: me.osInfoData.ciInstanceId,
            ipaddressApplytype: me.osInfoData.ipaddressApplytype,
          };
          if (!isNil(me.osInfoData.ipaddressIpv4)) {
            osObj.ipaddressIpv4 = me.osInfoData.ipaddressIpv4;
          }
          if (!isNil(me.osInfoData.ipaddressIpv6)) {
            osObj.ipaddressIpv6 = me.osInfoData.ipaddressIpv6;
          }
          me.tableData = [];
          this.isLoading = true;
          serverInfoAPI.getOsEnvInfoByObj(osObj).then((response) => {
            if (response.data.success && !isNil(response.data.data)) {
              this.isLoading = false;
              me.tableData = JSON.parse(response.data.data);
            } else {
              this.$message(msgUtil.getResultMsgData(action, '환경 변수', false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, '환경 변수', false));
          }).finally(() => {
            this.isLoading = false;
          });
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, '서버 OS 정보', false));
        });
      } else {
        me.osInfoData = {};
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    checkDatetimeFormatter(value) {
      return (isNil(value) || value === '-') ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/server/os/index.vue